import React from "react";

export const EMOTIONS = ["CONFIDENT", "FEARFUL", "FOMO", "GREEDY", "NEUTRAL"];
export const EMOTION_COLORS = { CONFIDENT: "#00C805", FEARFUL: "#3A82F6", FOMO: "#FF9900", GREEDY: "#FFB800", NEUTRAL: "#A1A1AA" };

export default function EmotionSelector({ value, onChange, testidPrefix, colored = false, rowTestid }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid={rowTestid}>
      {EMOTIONS.map((e) => {
        const active = value === e;
        const activeCls = colored ? "bg-white/5 text-white" : "border-[#007AFF] text-[#007AFF] bg-[#007AFF]/10";
        const style = colored && active ? { borderColor: EMOTION_COLORS[e], color: EMOTION_COLORS[e] } : undefined;
        return (
          <button key={e} type="button" data-testid={`${testidPrefix}-${e}`} onClick={() => onChange(active ? "" : e)} style={style}
            className={`px-3 py-1.5 text-[10px] tracking-[0.2em] uppercase font-semibold rounded-sm border transition-colors ${
              active ? activeCls : "border-[#27272A] text-[#71717A] hover:text-white hover:border-[#3F3F46]"}`}>
            {e}
          </button>
        );
      })}
    </div>
  );
}
